import request from '@/utils/request'

// H5页面活动相关奖品数据获取
export function getActivityDetail(activityId) {
  return request({
    url: SEVSRS + `/activity/v1/info/${activityId}`,
    method: 'get'
  })
}
// H5页面积分中心数据获取
export function getAppintegral(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/info`,
    method: 'get',
    params
  })
}
// H5积分抽奖动态
export function getWinners(params) {
  return request({
    url: SEVSRS + `/prize/v1/winners`,
    method: 'get',
    params
  })
}
// H5页面积分中心签到
export function integralSignIn(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/signIn`,
    method: 'get',
    params
  })
}
// H5页面活动用户抽奖
export function activityDraw(data) {
  return request({
    url: SEVSRS + `/activity/v1/app/draw`,
    method: 'post',
    data
  })
}
// H5页面积分及中奖记录
export function integralRecord(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/integral-record`,
    method: 'get',
    params
  })
}
// H5核销验证码获取
export function getCode(params) {
  return request({
    url: SEVSRS + `/user/v1/app/pin`,
    method: 'get',
    params
  })
}
// H5核销验证码校验及中奖信息获取
export function getExchangeInfo(params) {
  return request({
    url: SEVSRS + `/prize/v1/exchange-info`,
    method: 'get',
    params
  })
}
// H5获取二维码接口
export function getCodeInfo(params) {
  return request({
    url: SEVSRS + `/files/v1/app/qr-code`,
    method: 'get',
    params
  })
}
// H5获奖名单手动核销
export function appManualOff(id) {
  return request({
    url: SEVSRS + `/activity/v1/app/manual/${id}`,
    method: 'get',
  })
}
// H5获取全部疾病数据
export function medicalcanonv1info(id) {
  return request({
    url: SEVSRS + `/medical-canon/v1/info?broadHeading=1`,
    method: 'get',
  })
}
// H5获取全部疾病详情
export function illnessdetail(name) {
  return request({
    url: SEVSRS + `/medical-canon/v1/illness-detail?typeName=${name}`,
    method: 'get',
  })
}
// H5获取全部疾病筛选
export function illnessall(name) {
  return request({
    url: SEVSRS + `/medical-canon/v1/illness-all`,
    method: 'get',
  })
}
// 京东购买
export function skipstore(name) {
  return request({
    url: SEVSRS + `/jd/v1/skip-store`,
    method: 'get',
  })
}
// 咨询列表
export function appnews() {
  return request({
    url: SEVSRS + `/study/v1/app/news?typeId=2`,
    method: 'get',
  })
}
// 用户查看是否有权益
export function equityinfo(data) {
  return request({
    url: SEVSRS + `/equity/v2/info?code=0001`,
    method: 'get',
  })
}
// 提交
export function assistsendemail(data) {
  return request({
    url: SEVSRS + `/outpatient/v1/assist-send-email`,
    method: 'post',
    data
  })
}
export function flag(name) {
  return request({
    url: SEVSRS + `/common/v1/service-click-add?flag=` + name,
    method: 'get',
  })
}
// 获取验证码
export function pin(name) {
  return request({
    url: SEVSRS + `/user/v1/app/pin?phone=` + name,
    method: 'get',
  })
}
// 登录
export function login(data) {
  return request({
    url: SEVSRS + `/user/v1/app/login?phone=` + data.phone + '&pin=' + data.authCode,
    method: 'get',
  })
}
// 注册
export function register(data) {
  return request({
    url: SEVSRS + `/user/v1/app/register`,
    method: 'post',
    data
  })
}
//步数
export function activity(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/activity/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
//血压
export function bloodpre(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/bloodpre/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
//睡眠
export function sleep(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/sleep/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
//紧急联系人列表
export function contacts() {
  return request({
    url: SEVSRS + `/user/v1/list/contacts`,
    method: 'get',
  })
}
//紧急联系人添加
export function addcontacts(data) {
  return request({
    url: SEVSRS + `/user/v1/save/contacts`,
    method: 'post',
    data
  })
}
//紧急联系人删除
export function deletecontacts(data) {
  return request({
    url: SEVSRS + `/user/v1/delete/contacts?id=` + data.id,
    method: 'get',
  })
}
//个人资料
export function health(data) {
  return request({
    url: SEVSRS + `/user/v1/health`,
    method: 'get',
  })
}
//编辑个人资料
export function uphealthinfo(data) {
  return request({
    url: SEVSRS + `/user/v1/up-health-info`,
    method: 'post',
    data
  })
}
//编辑个人资料
export function uphealthinfo2(data) {
  return request({
    url: SEVSRS + `/user/v2/up-health-info`,
    method: 'post',
    data
  })
}
// 用户设备绑定
export function binddevice(data) {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device?bindStatus=` + data.bindStatus + '&deviceCode=' + data.deviceCode + '&deviceType=' + data.deviceType + '&jsonBrs=' + data.jsonBrs,
    method: 'get',
  })
}
// 查询用户设备绑定
export function isbind(data) {
  return request({
    url: SEVSRS + `/device/v1/app/is-bind`,
    method: 'get',
  })
}
// 设备列表
export function devicelist(data) {
  return request({
    url: SEVSRS + `/device/v1/device-list`,
    method: 'get',
  })
}
// 设备绑定信息
export function binddeviceinfo() {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device-info`,
    method: 'get',
  })
}

/**
 * 获取用户已绑定设备列表
 * @param {Object} params - 请求参数
 * @param {String} params.parentDeviceType - 父级设备类型（可选）
 * @returns {Promise} 返回设备列表
 */
export function getBindDeviceList(params = {}) {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device-list`,
    method: 'get',
    params
  })
}
// 设备解绑
export function unbindbinddevice(data) {
  return request({
    url: SEVSRS + `/device/v1/app/unbind-bind-device?bindStatus=` + data.bindStatus + '&deviceCode=' + data.deviceCode + '&userCode=' + data.userCode + '&deviceType=' + data.deviceType,
    method: 'get',
  })
}
// 心电列表
export function findecglist(data) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-list?dayDate=` + data.dayDate,
    method: 'get',
  })
}
/**
 * 手表ECG分页列表（不限日期）
 * @param {Object} params
 * @param {number} params.pn - 页码，从1开始
 * @param {number} params.ps - 每页大小
 */
export function findEcgListPage(params) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-list-page`,
    method: 'get',
    params
  })
}
export function findecginfo(data) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-info?ecgId=` + data.ecgId,
    method: 'get',
  })
}

/**
 * 根据测量日期和用户编码查询心电仪器测量记录
 * @param {Object} params - 请求参数
 * @param {String} params.measurementDate - 测量日期（格式：yyyy-MM-dd）
 * @param {String} params.userCode - 用户编码
 */
export function getSwkMeasurementRecords(params) {
  return request({
    url: SEVSRS + `/swk-ecg/v1/measurements/by-date-user`,
    method: 'get',
    params
  })
}

/**
 * 数维康心电-根据用户编码分页查询测量记录（简化版，不限日期）
 * @param {Object} params
 * @param {string} params.userCode - 用户编码（必填）
 * @param {number} params.pageIndex - 页码，从1开始（可选，默认1）
 * @param {number} params.pageSize - 每页数量（可选，默认20）
 */
export function getSwkMeasurementsByUser(params) {
  return request({
    url: SEVSRS + `/swk-ecg/v1/measurements/by-user`,
    method: 'get',
    params
  })
}
export function rulesName(data) {
  return request({
    url: SEVSRS + `/rule-conf/v1/rules/34`,
    method: 'get',
  })
}
export function mearecordlist(data) {
  return request({
    url: SEVSRS + `/monitor/v1/mea-record-list`,
    method: 'post',
    data
  })
}
export function savemearecord(data) {
  return request({
    url: SEVSRS + `/monitor/v1/save-mea-record`,
    method: 'post',
    data
  })
}
export function logout(data) {
  return request({
    url: SEVSRS + `/user/v1/account/logout?pin=` + data.pin,
    method: 'get',
  })
}
export function medicaltag() {
  return request({
    url: SEVSRS + `/common/v1/medical/tag`,
    method: 'get',
  })
}

/**
 * 获取医疗标签数据
 * @param {Object} params - 请求参数
 * @param {string} params.type - 疾病类型：1001-普通疾病、2001-家族史疾病、3001-精神类疾病
 * @param {number} params.gender - 性别限制：0-无限制，1-男性用户才显示，2-女性用户才显示
 */
export function getMedicalTag(params) {
  return request({
    url: SEVSRS + `/common/v1/medical/tag`,
    method: 'get',
    params
  })
}
export function v2uphealthinfo(data) {
  return request({
    url: SEVSRS + `/user/v2/up-health-info`,
    method: 'post',
    data
  })
}
/**
 * 获取用户医疗标签数据
 * @param {Object} params - 请求参数
 * @param {string} params.type - 疾病类型：1001-个人史、2001-家族史
 */
export function getUserMedicalTag(params) {
  return request({
    url: SEVSRS + `/user/v1/user-medical-tag`,
    method: 'get',
    params
  })
}

/**
 * 获取跳转链接
 * @param {Object} data - 请求参数
 * @param {number} data.type - 类型：1-视频医生，2-图文医生，3-电话医生，45-购药商城
 */
export function getJumpUrl(data) {
  return request({
    url: SEVSRS + `/online-doctor/v1/get-jump-url`,
    method: 'post',
    data
  })
}

/**
 * 记录用户点击
 * @param {Object} data - 参数对象
 * @param {string} data.moduleName - 模块编码：GRAPHIC_DOCTOR(图文医生)、VIDEO_DOCTOR(视频医生)、PHONE_DOCTOR(电话医生)、PHARMACY_MALL(购药商城)、OUTPATIENT_COLLABORATION(门诊协作)、HEALTH_CHECK(健康查一查)、HEALTH_CONSULTATION(健康咨询)
 * @param {string} data.accessTime - 访问时间，格式 yyyy-MM-dd HH:mm:ss，可选，不传则后端默认当前时间
 */
export function recordUserAccess(data) {
  return request({
    url: SEVSRS + '/access-record/v1/record',
    method: 'post',
    data,
    noLoading: true // 不显示loading，因为这是后台记录接口
  })
}

/**
 * 查询血压仪设备测量数据
 * @param {Object} data - 请求参数
 * @param {string} data.queryType - 查询类型：SINGLE_DAY（单天）、MULTIPLE_DAYS（多天）
 * @param {string} data.queryDate - 单天查询日期，格式：yyyy-MM-dd
 * @param {string} data.startDate - 多天查询开始日期，格式：yyyy-MM-dd
 * @param {string} data.endDate - 多天查询结束日期，格式：yyyy-MM-dd
 */
export function queryBloodPressureMonitor(data) {
  return request({
    url: SEVSRS + `/blood-pressure-monitor/v1/query-blood-pressure`,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/activity.js